import { addToSuperProperties, removeFromSuperProperties } from '@/utils/eventSuperProperties';
import { hasActiveUserSession } from '@/utils/sessionManager';
import { v4 as uuidv4 } from 'uuid';
import { SEARCH_LOCAL_STORAGE_TYPES, SEARCH_TYPES } from '../../constants';

const initialSearch = {
  id: null,
  type: '',
};

export default {
  namespaced: true,

  state: {
    open: false,
    search: initialSearch,
  },

  mutations: {
    SET_OPEN(state, payload) {
      state.open = payload;
    },
    SET_SEARCH_PARAMS(state, payload) {
      state.search = {
        ...payload,
      };
    },
  },

  actions: {
    setSearchParams({ commit, state }, payload) {
      if (payload.id) {
        commit('SET_SEARCH_PARAMS', payload);
        return;
      }
      const isUserSessionActive = hasActiveUserSession();
      const searchId = uuidv4();
      const data = {
        ...payload,
      };

      if (
        !isUserSessionActive ||
        payload.type === SEARCH_TYPES.GLOBAL_SEARCH ||
        payload.type === SEARCH_TYPES.RELATED_SEARCH
      ) {
        data.id = searchId;
      } else if (payload.type === SEARCH_TYPES.CATEGORY_SEARCH) {
        data.id = state.search.id || searchId;
      }

      addToSuperProperties({ search_id: data.id });
      try {
        localStorage.setItem(SEARCH_LOCAL_STORAGE_TYPES.SEARCH_STATE, JSON.stringify(data));
        commit('SET_SEARCH_PARAMS', data);
      } catch (error) {
        console.log('Failed to set item to local storage.', error);
      }
    },

    clearSearchParams({ commit }) {
      commit('SET_SEARCH_PARAMS', initialSearch);
      removeFromSuperProperties('search_id');
      localStorage.removeItem(SEARCH_LOCAL_STORAGE_TYPES.SEARCH_STATE);
    },

    checkSearchId({ dispatch, state }, payload) {
      const queryParams = [
        'q',
        'subcategories',
        'specs',
        'filetypes',
        'applicationsSupported',
        'themes',
        'artstyles',
        'isolated',
        'date_added',
      ];
      const isCategorySearching = Object.keys(payload.query).some(query =>
        queryParams.includes(query),
      );

      if (!state.search.id || payload.path.includes('/search/') || isCategorySearching) {
        return;
      }

      dispatch('clearSearchParams');
    },
  },
};
